import * as React from 'react';
import Text from 'antd/lib/typography/Text';
import { ThunderboltOutlined } from '@ant-design/icons';

import { AutomationRun, AutomationStatus } from '@/types';
import { antGrey } from '../styles/globalStyles';
import { StepRunPanelSection } from './StepRunPanelSection';
import { StepAutomationRuns } from './StepAutomationRuns';
import { groupBy } from 'lodash';
import { colorForAutomationStatus, displayTextForAutomationStatus } from '@/helpers/displayHelpers';
import Flex from 'antd/lib/flex';

interface AutomationsSectionProps {
    automationRuns: AutomationRun[];
}

const getStatusText = (automationRuns: AutomationRun[]) => {
    const automationsByStatus = groupBy(automationRuns, 'status');
    const automationsByStatusEntries = Object.entries(automationsByStatus);
    const statusTexts = automationsByStatusEntries.map(([status, automations], index) => {
        const statusColor = colorForAutomationStatus(status as AutomationStatus, false);
        const isLast = index === automationsByStatusEntries.length - 1;
        return (
            <Text style={{ fontSize: 13, color: statusColor }}>
                {automations.length} {displayTextForAutomationStatus(status as AutomationStatus).toLowerCase()}
                {isLast ? '' : ','}
            </Text>
        );
    });

    return (
        <Flex align="center" gap={8}>
            {statusTexts}
        </Flex>
    );
};

export const AutomationsSection: React.FC<AutomationsSectionProps> = ({ automationRuns }) => {
    const statusText = getStatusText(automationRuns);

    return (
        <div style={{ marginBottom: 12 }}>
            <StepRunPanelSection
                icon={<ThunderboltOutlined style={{ color: antGrey.grey7, fontSize: 16 }} />}
                title="Automations"
                titleExtra={
                    statusText && (
                        <Text style={{ fontSize: 13, color: antGrey.grey6, marginLeft: 8 }}>{statusText}</Text>
                    )
                }
            >
                <StepAutomationRuns automationRuns={automationRuns} />
            </StepRunPanelSection>
        </div>
    );
};
